module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro-norming.d38aa6cc.mp3";